import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { getAlternativeStepFlowsList } from "store/recipe/recipe.utils";
import { workspaceRecipesSelector } from "store/rs-workspace/selectors/rs-workspace.selectors";
const AlternativeFlowValue = ({ value, column }) => {
    const recipes = useSelector(workspaceRecipesSelector);
    const resultValue = useMemo(() => {
        const flows = getAlternativeStepFlowsList(recipes, column.parameter.name);
        return flows.find((_, idx) => `${idx}` === value);
    }, [column.parameter, recipes, value]);
    return React.createElement("span", null, resultValue);
};
export default AlternativeFlowValue;
